"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledSystem = require("styled-system");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = _interopRequireDefault(require("../../../theme"));

var _rebass = require("rebass");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Text = (0, _styledComponents["default"])(_rebass.Text).withConfig({
  displayName: "Text",
  componentId: "sc-1xmd5fh-0"
})(["", ""], _styledSystem.display);
Text.defaultProps = {
  theme: _theme["default"],
  as: 'span',
  lineHeight: '1.25em'
};
var _default = Text;
exports["default"] = _default;